<template>
  <section class="section" id="root">
    <div class="header">
      <div class="backBtn" v-on:click="goBack"></div>
      <h4 v-if="st === 1">Ukuran Baju</h4>
      <h4 v-else-if="st === 2">Ukuran Baju</h4>
      <h4 v-else-if="st === 3">Alamat</h4>
    </div>
    <div v-if="st === 1" class="mealPlanIntro">
      <img src="../assets/t-shirt.png">
      <h5>Kaos Finisher</h5>
      <p>Pilih ukuran baju yang sesuai dengan kamu untuk hadiah Finisher nanti</p>
      <p><b>A: Lebar dada<br />B: Panjang kaos</b></p>
      <div class="nameFormCnt">
        <form class="nameForm" v-on:submit.prevent="handleSubmit">
          <button class="btn primary block" :class="{btnLoading: formLoading}">
            <span>Berikutnya</span>
          </button>
        </form>
      </div>
    </div>
    <form v-on:submit.prevent="handleSubmit"
      v-else-if="st === 2" class="st4">
      <div class="tdeeCnt">
        <h4>Spec Size Finisher T Shirt</h4>
        <div class="tdeeSelector t-shirt">
          <div class="tdeeItem left"
            :class="{selected: tdee === 'Slimfit'}"
            v-on:click="selectTdee('Slimfit')">
            <h4>SLIMFIT</h4>
            <p>Lebar Dada (A): 45 cm</p>
            <div class="divider"></div>
            <p>Panjang Kaos (B): 63 cm</p>
          </div>
          <div class="tdeeItem"
            :class="{selected: tdee === 'S'}"
            v-on:click="selectTdee('S')">
            <h4>S</h4>
            <p>Lebar Dada (A): 50 cm</p>
            <div class="divider"></div>
            <p>Panjang Kaos (B): 70 cm</p>
          </div>
          <div class="tdeeItem left"
            :class="{selected: tdee === 'M'}"
            v-on:click="selectTdee('M')">
            <h4>M</h4>
            <p>Lebar Dada (A): 52 cm</p>
            <div class="divider"></div>
            <p>Panjang Kaos (B): 72 cm</p>
          </div>
          <div class="tdeeItem"
            :class="{selected: tdee === 'L'}"
            v-on:click="selectTdee('L')">
            <h4>L</h4>
            <p>Lebar Dada (A): 54 cm</p>
            <div class="divider"></div>
            <p>Panjang Kaos (B): 74 cm</p>
          </div>
          <div class="tdeeItem left"
            :class="{selected: tdee === 'XL'}"
            v-on:click="selectTdee('XL')">
            <h4>XL</h4>
            <p>Lebar Dada (A): 56 cm</p>
            <div class="divider"></div>
            <p>Panjang Kaos (B): 76 cm</p>
          </div>
          <div class="tdeeItem"
            :class="{selected: tdee === 'XXL'}"
            v-on:click="selectTdee('XXL')">
            <h4>XXL</h4>
            <p>Lebar Dada (A): 58 cm</p>
            <div class="divider"></div>
            <p>Panjang Kaos (B): 77 cm</p>
          </div>
        </div>
      </div>
      <div class="nameFormCnt">
        <form class="nameForm" v-on:submit.prevent="handleSubmit">
          <button class="btn primary block" :class="{btnLoading: formLoading}">
            <span>Berikutnya</span>
          </button>
        </form>
      </div>
    </form>
    <form v-on:submit.prevent="handleSubmit"
      v-else-if="st === 3" class="st4">
      <div class="tdeeCnt loading" v-if="loadingAddress"></div>
      <div class="tdeeCnt address" v-else>
        <div class="addressCnt">
          <!-- <h4 class="addrTtle">Alamat</h4> -->
          <p class="addrDesc">Masukan alamat untuk pengiriman Kaos Finisher.</p>
          <div class="fieldGroup">
            <label>Nama Penerima</label>
            <div class="fieldCnt" :class="{hasError: addr.name.error}">
              <input type="text" class="field" placeholder="Nama penerima"
                v-model="addr.name.model" v-on:input="addr.name.error = null">
              <div class="fieldError">Mohon isi nama penerima paket.</div>
            </div>
          </div>
          <div class="fieldGroup">
            <label>No. Telp.</label>
            <div class="fieldCnt" :class="{hasError: addr.phone.error}">
              <input type="text" class="field" placeholder="No. Telp."
                v-model="addr.phone.model" v-on:input="addr.phone.error = null">
              <div class="fieldError">Mohon isi No. Telp. penerima paket.</div>
            </div>
          </div>
          <div class="fieldGroup">
            <label>Alamat</label>
            <div class="fieldCnt" :class="{hasError: addr.address.error}">
              <textarea rows="3" class="field" placeholder="Alamat lengkap..."
                v-model="addr.address.model"
                v-on:input="addr.address.error = null"></textarea>
              <div class="fieldError">Mohon isi alamat lengkap.</div>
              <div class="fieldHint">Tolong diisi dengan <b>LENGKAP</b>
                alamat pengiriman hadiah Jersey. Alamat tidak lengkap akan
                menghambat pengiriman.</div>
            </div>
          </div>
          <div class="fieldGroup">
            <label>Provinsi</label>
            <div class="fieldCnt" :class="{hasError: addr.province.error}">
              <select class="field" v-model="addr.province.model"
                v-on:change="provinceChanged(false)">
                <option value="0" v-if="loadingProvince">Loading...</option>
                <option value="0" v-else>Pilih provinsi</option>
                <option v-for="item in provinces" :key="`prov${item.id}`"
                  :value="item.id">{{item.name}}</option>
              </select>
              <div class="fieldError" v-if="addr.province.error">
                Mohon pilih provinsi.
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <label>Kota/Kabupaten</label>
            <div class="fieldCnt" :class="{hasError: addr.city.error}">
              <select class="field" v-model="addr.city.model"
                v-on:change="cityChanged(false)">
                <option value="0" v-if="loadingCity">Loading...</option>
                <option value="0" v-else>Pilih kota</option>
                <option v-for="item in cities" :key="`prov${item.id}`"
                  :value="item.id">{{item.name}}</option>
              </select>
              <div class="fieldError" v-if="addr.city.error">
                Mohon pilih kota / kabupaten.
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <label>Kecamatan</label>
            <div class="fieldCnt" :class="{hasError: addr.district.error}">
              <select class="field" v-model="addr.district.model"
                v-on:change="addr.district.error = null">
                <option value="0" v-if="loadingDistrict">Loading...</option>
                <option value="0" v-else>Pilih kecamatan</option>
                <option v-for="item in districts" :key="`prov${item.id}`"
                  :value="item.id">{{item.name}}</option>
              </select>
              <div class="fieldError" v-if="addr.district.error">
                Mohon pilih kecamatan.
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <label>Kode Pos</label>
            <div class="fieldCnt" :class="{hasError: addr.postalCode.error}">
              <input type="text" class="field" placeholder="Kode pos..."
                v-model="addr.postalCode.model">
              <div class="fieldError">
                Mohon isi kode POS.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nameFormCnt">
        <form class="nameForm" v-on:submit.prevent="handleSubmit">
          <button class="btn primary block" :class="{btnLoading: formLoading}">
            <span>Berikutnya</span>
          </button>
        </form>
      </div>
    </form>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { Confirmation },
  data() {
    return {
      st: 1,
      tdee: 'Slimfit',
      formLoading: false,
      addr: {
        name: { model: '', error: null },
        phone: { model: '', error: null },
        address: { model: '', error: null },
        district: { model: '0', error: null },
        city: { model: '0', error: null },
        province: { model: '0', error: null },
        postalCode: { model: '', error: null },
      },
      provinces: [],
      loadingProvince: true,
      cities: [],
      loadingCity: false,
      districts: [],
      loadingDistrict: false,
      loadingAddress: true,
      userAddress: null,
    };
  },
  created() {},
  destroyed() {},
  methods: {
    doNothing() {},
    goBack() {
      if (this.$route.query.address === 'y') window.history.back();
      else if (this.st <= 1) window.history.back();
      else this.st -= 1;
    },
    selectTdee(tdee) {
      this.tdee = tdee;
    },
    cityChanged(init) {
      this.addr.city.error = null;
      this.loadingDistrict = true;
      if (!init) this.addr.district.model = '0';
      this.districts = [];
      this.$http.get(this.$config.uri(`misc/${this.addr.city.model}/districts`)).then((r) => {
        this.loadingDistrict = false;
        this.districts = (r.data.status === 200) ? r.data.data : [];
      });
    },
    provinceChanged(init) {
      this.addr.province.error = null;
      this.loadingCity = true;
      if (!init) this.addr.city.model = '0';
      this.cities = [];
      this.$http.get(this.$config.uri(`misc/${this.addr.province.model}/cities`)).then((r) => {
        this.loadingCity = false;
        this.cities = (r.data.status === 200) ? r.data.data : [];
        if (init && this.userAddress) this.cityChanged(init);
      });
    },
    doSaveAddress(next) {
      if (this.formLoading) return;
      this.formLoading = true;
      const formData = {
        name: this.addr.name.model,
        phone: this.addr.phone.model,
        postalCode: this.addr.postalCode.model,
        address: this.addr.address.model,
        provinceId: this.addr.province.model.toString(),
        cityId: this.addr.city.model.toString(),
        districtId: this.addr.district.model.toString(),
      };
      this.$http.post(this.$config.uri('user/address'), formData).then((r) => {
        this.formLoading = false;
        next();
      });
    },
    saveAddress(next) {
      const formData = {
        name: this.addr.name.model,
        phone: this.addr.phone.model,
        postalCode: this.addr.postalCode.model,
        address: this.addr.address.model,
        provinceId: this.addr.province.model.toString(),
        cityId: this.addr.city.model.toString(),
        districtId: this.addr.district.model.toString(),
      };

      if (!formData.name) {
        this.addr.name.error = true;
        return;
      }
      if (!formData.phone) {
        this.addr.phone.error = true;
        return;
      }
      if (!formData.address) {
        this.addr.address.error = true;
        return;
      }
      if (formData.provinceId === '0') {
        this.addr.province.error = true;
        return;
      }
      if (formData.cityId === '0') {
        this.addr.city.error = true;
        return;
      }
      if (formData.districtId === '0') {
        this.addr.district.error = true;
        return;
      }
      if (!formData.postalCode) {
        this.addr.postalCode.error = true;
        return;
      }

      this.doSaveAddress(next);

      // if (!formData.address) {
      //   this.$refs.confirmDialog.open({
      //     title: 'Alamat belum diisi',
      //     desc: `Apakah kamu yakin ingin melanjutkan tanpa mengisi alamat?
      //       Kamu bisa mengisi alamat nanti pada bagian profil.`,
      //     action: 'Lanjutkan',
      //   }, (b) => {
      //     if (!b) return;
      //     this.doSaveAddress(next);
      //   });
      // } else if (formData.provinceId === '0' || formData.cityId === '0') {
      //   this.$refs.confirmDialog.open({
      //     title: 'Alamat tidak lengkap',
      //     desc: `Apakah kamu yakin ingin melanjutkan dengan alamat tidak lengkap?
      //       Kamu bisa mengubah alamat nanti pada bagian profil.`,
      //     action: 'Lanjutkan',
      //   }, (b) => {
      //     if (!b) return;
      //     this.doSaveAddress(next);
      //   });
      // } else {
      //   this.doSaveAddress(next);
      // }
    },
    doSave() {
      if (this.formLoading) return;
      this.formLoading = true;
      this.$session.set('bk6_tshirt_size', this.tdee);
      this.$http.post(this.$config.uri('user/t-shirt/size'), {
        tshirtSize: this.tdee,
      }).then((r) => {
        this.formLoading = false;
        this.$router.push('/main');
      });
    },
    handleSubmit() {
      if (this.formLoading) return;
      if (this.st === 1) {
        this.st = 2;
      } else if (this.st === 2) {
        if (this.$route.query.edit === 'y') {
          this.doSave();
          return;
        }
        this.st = 3;
      } else {
        this.saveAddress(() => {
          if (this.$route.query.address === 'y') {
            this.$router.push('/main');
            return;
          }
          this.doSave();
        });
      }
    },
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email')) {
      this.$router.push('/login');
      return;
    }
    if (this.$route.query.address === 'y') {
      this.st = 3;
    }
    this.$http.get(this.$config.uri('user/address')).then((r) => {
      this.loadingAddress = false;
      this.userAddress = (r.data.status === 200) ? r.data.data : null;
      if (this.userAddress) {
        this.addr.name.model = this.userAddress.name;
        this.addr.phone.model = this.userAddress.phone;
        this.addr.address.model = this.userAddress.address;
        this.addr.province.model = this.userAddress.provinceId || '0';
        this.addr.city.model = this.userAddress.cityId || '0';
        this.addr.district.model = this.userAddress.districtId || '0';
        this.addr.postalCode.model = this.userAddress.postalCode;
      }
      this.$http.get(this.$config.uri('misc/provinces')).then((r2) => {
        this.loadingProvince = false;
        this.provinces = (r2.data.status === 200) ? r2.data.data : [];
        if (this.userAddress) {
          this.provinceChanged(true);
        }
      });
    });
    this.addr.name.model = this.$session.get('bk6_name') || '';
    this.tdee = this.$session.get('bk6_tshirt_size') || 'Slimfit';
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });
  },
};
</script>

<style scoped lang="scss">
.birthDateInfo{
  font-size: 14px;
  margin: 0 0 10px 7px;
  line-height: 1.2;
  color: #444;
}
.bdArrow{
  width: 20px; height: 20px;
  background-image: url(../assets/arrow-down.png);
  background-size: cover;
  margin: 0 0 10px 60px;
}

.pageLoading{
  position: fixed;
  left: 0; right: 0; bottom: 100px; top: 100px;
  background-image: url(../assets/loading.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 54px auto;
}

.mealPlanIntro{
  text-align: center;
  padding: 100px 20px;
  @media (max-height: 625px) {
    padding: 100px 20px 0;
  }
  img{
    width: 76%;
    max-width: 300px;
    margin: 0 0 20px;
  }
  h5{
    margin: 0 0 10px;
    font-size: 20px;
  }
  p{
    margin: 0;
    font-size: 15px;
    @media (max-height: 625px) {
      margin: 0 0 40px;
    }
  }
}

.fieldError{
  color: red;
  display: none;
}
.hasError{
  .field{
    border-color: red;
  }
  .fieldError{
    display: block;
  }
}

.section{
  padding: 30px 0;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 768px) {
    min-height: calc(100vh - 60px);
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 24px;
    margin: 0 0 20px;
    text-align: left;
  }
  .header{
    padding: 16px 20px 0;
    margin: -30px 0 0;
    position: relative;
    z-index: 9;
    display: flex;
    .progress{
      position: absolute;
      top: 0; left: 0; height: 3px;
      background-color: #8dc53f;
    }
    @media (min-width: 480px) {
      padding-left: 0;
      padding-right: 0;
    }
    .backBtn{
      width: 46px; height: 46px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-back.png);
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 9;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 22px;
      margin: 11px 0 0 20px;
      position: relative;
      width: calc(100% - (46px + 20px));
      .qIdx{
        position: absolute;
        right: 0; top: 6px;
        display: block;
        font-weight: normal;
        font-size: 13px;
        color: #767676;
      }
    }
  }
}
.tdeeCnt{
  padding: 16px 0;
  &.loading{
    height: 400px;
    background-image: url(../assets/loading.svg);
    background-size: 36px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  @media (max-width: 480px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  h4{
    color: #444;
    font-size: 18px;
    margin: 0 0 6px;
    &.addrTtl{
      margin: 0;
    }
  }
  p.addrDesc{
    margin: 0 0 20px;
    font-size: 14px;
  }
  &.address{
    position: fixed;
    top: 72px; right: 0; left: 150px; bottom: 100px;
    overflow: auto;
    border-top: #ccc 1px solid;
    border-bottom: #ccc 1px solid;
    @media (max-width: 768px) {
      left: 0; top: 130px;
    }
    @media (max-height: 625px) {
      position: static;
      border: none;
    }
    .fieldHint{
      margin-left: 7px;
      line-height: 1.1;
      font-size: 14px;
    }
    .addressCnt{
      max-width: 460px;
      margin: 0 auto;
    }
    .addrDesc{
      text-align: center;
      display: none;
    }
  }
  .tdeeSelector{
    display: flex;
    flex-wrap: wrap;
    .tdeeItem{
      width: calc(50% - 5px);
      background-color: #fff;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
      padding: 12px 14px;
      box-sizing: border-box;
      margin-bottom: 10px;
      border-radius: 5px;
      position: relative;
      border: #fff 2px solid;
      cursor: pointer;
      &:hover{
        border-color: #999;
      }
      &:before{
        width: 16px; height: 16px;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/circle-bg-inactive.png);
        background-size: 16px auto;
        content: "";
        opacity: .5;
      }
      &:active{
        background-color: #ddd;
      }
      &.left{
        margin-right: auto;
      }
      .divider{
        border-top: #e5e5e5 1px solid;
        margin-top: 10px;
        padding-bottom: 10px;
        // display: none;
      }
      h4{
        font-size: 22px;
        margin: 0 0 8px;
        color: #006519;
      }
      p{
        margin: 0;
        font-size: 13px;
        line-height: 1.1;
      }
      &.selected{
        border-color: #006519;
        &:before{
          background-image: url(../assets/checked-green.png);
          opacity: 1;
        }
      }
      &.upload{
        width: calc(50% - 8px);
        background-color: #fff;
        border: none;
        border-color: #eee;
        padding: 150px 16px 0;
        height: 280px;
        box-sizing: border-box;
        background-position: center;
        background-size: cover;
        margin: 0 0 10px;
        &.right{
          margin-left: auto;
        }
        &.mid{ display: none !important; }
        &.foto360{ display: none !important; }
        @media (max-width: 500px) {
          height: 200px;
          padding: 110px 6px 0;
        }
        &:hover{
          background-color: #f5f5fe;
        }
        &.mid{
          margin: 0 auto 10px;
        }
        &:before{
          left: 50%; top: 96px;
          width: 46px; height: 46px;
          background-size: 46px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url(../assets/upload-image.png);
          margin-left: -23px;
          @media (max-width: 500px) {
            top: 56px;
          }
        }
        h4{
          text-align: center;
          color: #767676;
          font-size: 14px;
          @media (max-width: 500px) {
            font-size: 13px;
          }
        }
        &.hasPhoto{
          h4{ display: none; }
          &:before{ display: none; }
        }
        &.hasError{
          border-color: red;
          box-shadow: none;
          color: red;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 0 10px;
          font-size: 15px;
          background-color: #fff3f3;
          &:before{ display: none; }
          h4{ display: none; }
        }
        &.uploading{
          box-shadow: none;
          background-color: #ddd;
          border-color: #ddd;
          background-image: url(../assets/loading.svg) !important;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 46px auto;
          h4{ display: none; }
          &:before{ display: none; }
        }
      }
    }
  }
  .purposeCnt{
    height: calc(100vh - 300px);
    display: flex;
    justify-content: center;
    align-items: center;
    .tdeeSelector{
      display: block;
      width: 100%;
      .tdeeItem{
        width: auto;
        h4{
          margin: 0;
        }
      }
    }
  }
}

.nameFormCnt{
  position: fixed;
  left: 150px; right: 0; bottom: 0;
  z-index: 3;
  @media (max-width: 768px) {
    left: 0;
  }
  @media (max-height: 625px) {
    position: static;
  }
}
.nameForm{
  position: absolute;
  bottom: 40px; width: 460px;
  left: 50%; margin-left: -230px;
  @media (max-width: 500px) {
    left: 20px; right: 20px;
    width: auto; margin: 0;
  }
  @media (max-height: 625px) {
    position: static;
    margin: 0;
  }
}
</style>
